import { attachShadow, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
export { setAssetPath } from '@stencil/core/internal/client';

const latestCoveragesCss = ":host{display:block;font-family:\"Noto Sans CJK TC\", system-ui, -apple-system, sans-serif}h3,p{margin:0;line-height:1.5}h3{color:rgba(0, 0, 0, 0.87);font-size:17px}a{display:block;text-decoration:none}p{color:rgba(0, 0, 0, 0.660637);font-size:13px;line-height:1.5}.coverage{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.coverage+.coverage{margin:10px 0 0}.coverage__image img{display:block;width:82px;height:82px;-o-object-position:center center;object-position:center center;-o-object-fit:cover;object-fit:cover}.coverage__info{-ms-flex:1;flex:1;margin:0 0 0 20px}.coverage__info h3{display:-webkit-box;text-align:justify;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden}.coverage__info p{margin:10px 0 0}@media screen and (min-width: 768px){h3{font-size:20px}.coverage+.coverage{margin:20px 0 0}.coverage__image img{width:200px;height:101px}}";

const TEMP_OLD_PROJECTS_SLUGS = [
    'china-company',
    'unitedfront',
    'food-delivery',
    'extra-curriculum',
    'election-2020',
    'formosaincident',
    'the-third-force',
    'maskmap',
    'ncov2019search',
    'backtoformosa',
    'covid19-disinformation-vis',
    'covid19-disinformation',
    'eid',
];
const DATA_URL = 'https://www.readr.tw/api/public/posts?type={"$in":[1,4]}&sort=-published_at&max_result=3';
const NEWS_URL = 'https://www.readr.tw/post';
const REPORT_URL = 'https://www.readr.tw/project/3';
const OLD_REPORT_URL = 'https://www.readr.tw/project';
function format(datatimeString) {
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(datatimeString);
    return `${MONTHS[date.getMonth()]}. ${date.getDate()}, ${date.getFullYear()}`;
}
function restructureData(data) {
    return ({
        title: data.title,
        href: data.type === 4 ? getReportHref(data.slug) : `${NEWS_URL}/${data.id}`,
        image: data.og_image || data.hero_image,
        publishedAt: format(data.published_at),
    });
}
function getReportHref(slug) {
    return TEMP_OLD_PROJECTS_SLUGS.some((ele) => ele === slug) ? `${OLD_REPORT_URL}/${slug}` : `${REPORT_URL}/${slug}`;
}
async function fetchData(url) {
    try {
        const response = await fetch(url);
        const { _items = [] } = await response.json();
        return _items;
    }
    catch (error) {
        console.error('fetchData error:', error);
        return [];
    }
}
const LatestCoverages = class extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        attachShadow(this);
    }
    async componentWillLoad() {
        const items = await fetchData(DATA_URL);
        this.coverages = items.map((item) => restructureData(item));
    }
    render() {
        return (h(Host, null, this.coverages.map((coverage) => h("div", { class: "coverage" }, h("a", { class: "coverage__image", href: coverage.href, target: "_blank" }, h("img", { src: coverage.image, alt: coverage.title })), h("a", { class: "coverage__info", href: coverage.href, target: "_blank" }, h("h3", null, coverage.title), h("p", null, coverage.publishedAt))))));
    }
    static get style() { return latestCoveragesCss; }
};

const LatestCoverages$1 = /*@__PURE__*/proxyCustomElement(LatestCoverages, [1,"latest-coverages",{"coverages":[32]}]);
const defineCustomElements = (opts) => {
  if (typeof customElements !== 'undefined') {
    [
      LatestCoverages$1
    ].forEach(cmp => {
      if (!customElements.get(cmp.is)) {
        customElements.define(cmp.is, cmp, opts);
      }
    });
  }
};

export { LatestCoverages$1 as LatestCoverages, defineCustomElements };
